// Environment-aware logging utility
// Only logs in development and staging, not in production

// Debug: Always log hostname on load to verify logger is working
if (typeof window !== 'undefined') {
  console.log('[Logger] Hostname:', window.location.hostname, '| isProd:', window.location.hostname === 'k-skin.ai' || window.location.hostname === 'www.k-skin.ai')
}

const isStaging = (): boolean => {
  if (typeof window === 'undefined') return false
  const hostname = window.location.hostname
  return (
    hostname === 'localhost' ||
    hostname.includes('staging') ||
    hostname.includes('amplifyapp.com')  // All Amplify preview URLs
  )
}

const isProd = (): boolean => {
  if (typeof window === 'undefined') return false
  const hostname = window.location.hostname
  // Production domains - add your production domain here
  return hostname === 'k-skin.ai' || hostname === 'www.k-skin.ai'
}

// Debug logger - only logs in staging/dev
export const debugLog = (...args: unknown[]): void => {
  if (!isProd()) {
    console.log(...args)
  }
}

// Always logs (for critical errors)
export const errorLog = (...args: unknown[]): void => {
  console.error(...args)
}

// Conditional logging based on environment
export const logger = {
  debug: debugLog,
  log: debugLog,
  warn: (...args: unknown[]) => !isProd() && console.warn(...args),
  error: errorLog,
  isStaging,
  isProd,
}

export default logger
